import React from 'react';

interface Props {
  title: string;
  description?: string;
  breadcrumb?: React.ReactNode;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<Props> = ({
  title,
  description,
  breadcrumb,
  actions,
}) => {
  return (
    <header className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        {breadcrumb && (
          <div className="mb-2 text-sm text-slate-500">{breadcrumb}</div>
        )}
        <h1 className="font-display text-[2rem] font-medium leading-[1.1] tracking-tight text-slate-900">
          {title}
        </h1>
        {description && (
          <p className="mt-2 max-w-2xl text-[15px] text-slate-600">{description}</p>
        )}
      </div>
      {actions && (
        <div className="flex shrink-0 items-center gap-2 sm:justify-end">{actions}</div>
      )}
    </header>
  );
};

export default PageHeader;
